import styled from "styled-components";

export const Main = styled.div`
  width: 100%;
  min-height: calc(100vh - (${({ theme }) => theme.spacing.headerHeight} + ${({ theme }) => theme.spacing.footerHeight} + 2rem + 4rem));
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding-top: 3rem;
  gap: 5rem;

  .forgot-password {
    color: ${({ theme }) => theme.colors.secondary.health_green};
    text-decoration: underline;
    font-weight: ${({ theme }) => theme.fontWeight.fontWeight.fontWeightBold};
    line-height: ${({ theme }) => theme.lineHeight.lineHeight.lineHeightNormal};
    font-size: ${({ theme }) => theme.fontSize.fontSize.fontSizeBase};
    padding-left: 2px;

    :hover {
      color: ${({ theme }) => theme.colors.green[600]};
    }

    :focus {
      color: ${({ theme }) => theme.colors.green[900]};
    }

    :active {
      color: ${({ theme }) => theme.colors.green[900]};
    }

    @media screen and (max-width: 500px) {
      padding-top: 8px;
    }
  }

  @media screen and (max-width: 1020px) {
    padding: ${({ theme }) => theme.spacing.s} ${({ theme }) => theme.spacing.xl};
    flex-direction: column-reverse;
    align-items: center;
    justify-content: center;
    gap: ${({ theme }) => theme.spacing.m};
  }

  @media screen and (max-width: 1000px) {
    flex-direction: column;
    padding: 0 1.5rem;
  }

  @media screen and (max-width: 500px) {
    padding: 1.5rem 0 4rem;
    border-bottom: 1px solid ${({ theme }) => theme.colors.auxiliary.green};
    gap: ${({ theme }) => theme.spacing.l};
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.l};
  width: 100%;
  max-width: 34.125rem;
  margin-bottom: ${({ theme }) => theme.spacing.layoutl};

  form {
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing.s};
    width: 100%;
    max-width: 34.125rem;

    @media screen and (max-width: 1000px) {
      max-width: none;
      width: 100%;
    }
  }

  @media screen and (max-width: 1000px) {
    max-width: 48rem;
  }

  @media screen and (max-width: 500px) {
    margin: 0 auto;
    gap: ${({ theme }) => theme.spacing.m};
  }
`;

export const AnaliseInscricao = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.s};

  p {
    font-size: ${({ theme }) => theme.fontSize.fontSize.fontSizeBase};
    font-weight: ${({ theme }) => theme.fontWeight.fontWeight.fontWeightNormal};
    line-height: ${({ theme }) => theme.lineHeight.lineHeight.lineHeightNormal};
    color: #c75126;

    @media screen and (max-width: 762px) {
      font-size: ${({ theme }) => theme.fontSize.fontSize.fontSizeSM};
    }
  }
`;

export const ButtonsWrapper = styled.div`
  margin-top: ${({ theme }) => theme.spacing.s};
  margin-bottom: -0.5rem;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.m};

  @media screen and (max-width: 768px) {
    max-width: 100%;
  }

`;

export const SubtitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  color: ${({ theme }) => theme.colors.auxiliary.black};

  h1 {
    font-size: ${({ theme }) => theme.fontSize.fontSize.fontSizeXL};
    line-height: 2.25rem; // TODO: necessário correção no theme (está com em)
    font-weight: ${({ theme }) => theme.fontWeight.fontWeight.fontWeightBold};
    display: flex;
    flex-wrap: wrap;
    gap: 0.4rem;

    @media screen and (max-width: 500px) {
      font-size: 1.5rem;
      padding-bottom: 4px;
    }
  }

  p {
    font-size: ${({ theme }) => theme.fontSize.fontSize.fontSizeBase};
    line-height: 1.5rem;

    @media screen and (max-width: 500px) {
      font-weight: ${({ theme }) => theme.fontWeight.fontWeight.fontWeightNormal};
    }

    @media screen and (max-width: 360px) {
      font-size: ${({ theme }) => theme.fontSize.fontSize.fontSizeBase};
    }
  }

  .divider {
    height: 2px;
    width: 10rem;
    background-color: ${({ theme }) => theme.colors.secondary.health_green};
    margin-top: ${({ theme }) => theme.spacing.xs};
    margin-bottom: ${({ theme }) => theme.spacing.s};
  }

  @media screen and (max-width: 768px) {
    max-width: 100%;
  }
`;

export const Span = styled.span`
  width: 35%;
  padding: 0.063rem 0;
  background-color: ${({ theme }) => theme.colors.secondary.health_green};
`;

export const ImageWrapper = styled.div`
  width: 100%;
  max-width: 34.125rem;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-bottom: 5.75rem;

  .pro-image {
    width: 100%;
    height: auto;
  }

  .image-credits {
    color: ${({ theme }) => theme.colors.gray.dark};
    font-size: ${({ theme }) => theme.fontSize.fontSize.fontSizeXS};
    text-align: right;
    white-space: nowrap;

    .anchor-image {
      cursor: pointer;
      color: ${({ theme }) => theme.colors.gray.dark};
      text-decoration: none;
    }
  }

  @media screen and (max-width: 500px) {
    margin: 0 auto;
    max-width: 100%;
  }
`;
